"use client";

import React from "react";
import { createAdvancedStore } from "@/stores/createAdvancedStore";

//

export const nonceStore = createAdvancedStore<{ nonce: string | undefined }>("Nonce");
export const useNonceStore = nonceStore.useContext;

//

export interface NonceProviderProps {
  children?: React.ReactNode;
  nonce: string | undefined;
}

//

export const NonceProvider: React.FC<NonceProviderProps> = ({ children, nonce }) => {
  return <nonceStore.Provider value={{ nonce }}>{children}</nonceStore.Provider>;
};
